"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var identifiers_1 = require("../identifiers");
var AutoComplete_1 = require("./AutoComplete");
var theme = require("./theme.scss");
exports.default = AutoComplete_1.default(identifiers_1.AUTO_COMPLETE, theme);
